import { LoadingOverlay } from "@mantine/core";
import { useParams } from "react-router";
import useSwr from "swr";
import { NetworkApi } from "../../apis";
import { OrderForm } from "../../components/order";

export function BuyerCustomerOrder() {
  const params = useParams();

  const { data, isLoading } = useSwr(
    `/ord/network/get/order.${params.id}`,
    async () => await NetworkApi.get(params.id as string),
    { fallback: { data: null } }
  );

  return (
    <>
      {data && (
        <>
          <LoadingOverlay visible={isLoading} />
          <OrderForm
            mode="create"
            side="buyer"
            preselectedPartner={data}
            backPath="/buyer-customer"
          />
        </>
      )}
    </>
  );
}
